import styled from 'styled-components';

export const HeaderComponent = styled.header`
  display: flex;
  position: sticky;
  width: 100%;
  box-sizing: border-box;
  top: 0;
  left: 0;
  width: 100%;
  height: 75px;
  color: ${(props) => props.secondaryColor};
  background: ${(props) => props.primaryColor};
  z-index: 10;
  @media screen and (max-width: 766px) {
    box-shadow: 0 3px 6px #00000024;
    height: 60px;
  }
`;

export const HeaderInner = styled.section`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  height: auto;
  z-index: 10;

  @media screen and (min-width: 767px) {
    padding: 0rem 2rem;
  }

  @media screen and (max-width: 766px) {
    padding: 10px 1rem;
  }
`;

export const HeaderSections = styled.div`
  display: flex;
  align-items: center;
  flex: 0 0 auto;
`;

export const CartTotalContainer = styled.span`
  display: inline-block;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  display: flex;
  font-weight: 500;
  flex: 0;
  font-size: 12px;
  align-items: center;
  justify-content: center;
  position: absolute;
  z-index: 2;
  background: ${(props) => props.backgroundColor};
  color: ${(props) => props.fontColor};
  top: 0;
  right: 0;
  transform: translateX(50%) translateY(-50%);
`;

// Mobile Dropdown Styles
export const MobileDropownContainer = styled.div`
  position: fixed;
  height: 100vh;
  width: 100%;
  background: rgba(0, 0, 0, 0.62);
`;

export const MobileHeaderDrawer = styled.div`
  display: ${(props) => (props.isOpen ? 'flex' : 'none')};
  width: 100%;
  height: fit-content;
  position: fixed;
  box-sizing: border-box;
  top: 0;
  left: 0;
  background: ${(props) => props.primaryColor};
  color: ${(props) => props.secondaryColor};
  padding-top: ${(props) => props.paddingTop || 0}px;
  max-height: 100vh;
  z-index: 5;
  box-shadow: 0px 2px 5px -2px rgba(0, 0, 0, 0.5);
`;

export const HeaderDrawerInner = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: ${(props) => `calc(100vh - ${props.heightLimiter}px)`};
  padding: 10px 0;
  max-width: 1180px;
  margin: 0 auto;
`;

export const HeaderExpandable = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-y: auto;
  border-bottom: 0.5px solid rgba(255, 255, 255, 0.07);
  max-height: ${(props) => `calc(100vh - ${props.heightLimiter}px)`};
`;

export const HeaderSection = styled.section`
  box-sizing: border-box;
  display: ${(props) => props.display};
  width: 100%;
  ${(props) => props.border && `border-bottom: 0.5px solid rgba(255,255,255,0.07);`};
  padding: 0.8rem 2rem;
  justify-content: ${(props) => props.justifyContent || 'flex-start'};
  align-items: ${(props) => props.alignItems || 'flex-start'};

  &:last-child {
    border-bottom: none;
  }
`;

export const HeaderExpandedList = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow-y: auto;
`;

export const HeaderExpandedListItem = styled.span`
  display: block;
  padding: 1rem 2rem;
  font-size: 15px;
  letter-spacing: 0.3px;
  cursor: pointer;
`;

export const HeaderSectionList = styled.div`
  display: flex;
  flex-direction: column;

  & > div {
    margin: 10px 0;
  }

  & > div:first-child {
    margin-top: 0;
  }

  & > div:last-child {
    margin-bottom: 0;
  }
`;

export const HeaderSectionListItem = styled.div`
  display: flex;
  font-size: 15px;
  align-items: center;

  & > p {
    margin-left: 10px;
  }
`;

export const MenuItem = styled.span`
  margin: ${(props) => props.margin || `0 0 0 20px`};
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  color: ${(props) => props.secondaryColor};
  position: relative;
  cursor: pointer;

  @media screen and (min-width: 767px) {
    font-size: 18px;
  }

  @media screen and (max-width: 766px) {
    font-size: 15px;
  }
`;

export const HeaderIcon = styled.span`
  display: ${(props) => props.display || `inline-block`};
  margin-left: 15px;
  height: ${(props) => `${props.size}px` || '16px'};
  width: ${(props) => `${props.size}px` || '16px'};
  transform: ${(props) => (props.iconPointer ? 'rotateZ(270deg)' : 'rotateZ(90deg)')};
  position: relative;
`;

export const StoreName = styled.span`
  color: ${(props) => props.fontColor};
  text-transform: uppercase;
  cursor: pointer;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 50vw;
  font-weight: 700;

  @media screen and (min-width: 767px) {
    margin-left: 15px;
    font-size: 24px;
    letter-spacing: 1.4px;
    display: -webkit-box;
  }

  @media screen and (max-width: 766px) {
    font-size: 14px;
    letter-spacing: 1.4px;
    display: ${(props) => (props.showStoreNameOnMobile ? `-webkit-box` : `none`)};
  }

  @media screen and (max-width: 350px) {
    max-width: 150px;
  }
`;

export const ShopingIconContainer = styled.div`
  background-color: ${(props) => props.backgroundColor};
  border-radius: 12px;
  height: 44px;
  width: 44px;
  padding: 12px 12px 8px 7px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ShopingIconWrap = styled.article`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`;
